class GTMHelper {
  constructor (options = {}) {
    const { dataLayer, eventCategory = 'claro:controle-facil' } = options
    this.$dataLayer = dataLayer
    this.$eventCategory = eventCategory
  }

  push (data) {
    if (this.$dataLayer) {
      this.$dataLayer.push(data)
      return
    }

    console.warn('dataLayer.push', data) // eslint-disable-line
  }

  log (eventAction, eventLabel) {
    const data = {
      event: 'event',
      eventCategory: this.$eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel
    }

    this.push(data)

    return data
  }
}

export { GTMHelper }
